module.exports = __webpack_public_path__ + "img/f5.25a6bdd.png";